<template>
    <div v-frag>
        <CardIeaAppMain colorCard="#2D3436" title="">
            <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
                <v-btn class="mx-2" fab dark small color="success" @click="$router.go(-1)">
                    <v-icon dark>
                        mdi-keyboard-backspace
                    </v-icon>
                </v-btn>
                <br /><br />
                <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
                <br />
                <div class="text-xs-h5 text-sm-h5 text-md-h5 text-lg-h5 text-xl-h5 primary-text">{{ subtitle }}</div>
                <br />
                <v-row no-gutters>
                    <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
                        <v-alert prominent type="info">
                            Declaración Jurada provisoria hasta el inicio de cursada. El personal de Directivo estará
                            informando a través de entrevistas en los diferentes canales de comunicación institucional
                            más detalles del inicio.
                            Es de responsabilidad del alumno la entrega en tiempo y forma de documentación respaldatoria
                            original para efectivizar la aprobación definitiva de las equivalencias provisorias.
                            Sólo se llenará una vez.
                        </v-alert>
                    </v-col>
                </v-row>
                <br>
                <v-card elevation="11" outlined shaped>
                    <v-card-title class="d-flex justify-left pl-16">Datos Personales
                    </v-card-title>
                    <v-card-title class="d-flex justify-left pl-16">
                        <v-row>
                            <v-col cols="8" sm="12" md="12" lg="8">
                                Apellido/s y Nombre/s del alumno:
                                <v-text-field v-model="formulario.nombre_completo" :disabled="!llenar"></v-text-field>

                            </v-col>
                            <v-col cols="8" sm="12" md="12" lg="8">
                                DNI
                                <v-text-field v-model="formulario.DNI" :disabled="!llenar"></v-text-field>

                            </v-col>
                            <v-col cols="8" sm="12" md="12" lg="8">
                                Edad
                                <v-text-field v-model="formulario.edad" :disabled="!llenar"></v-text-field>

                            </v-col>
                        </v-row>
                    </v-card-title>
                </v-card>

                <v-card elevation="11" outlined shaped class="mt-5">
                    <v-card-title class="d-flex justify-left pl-16">DATOS SOBRE MATERIAS Y AÑO DE MATRICULACIÓN
                    </v-card-title>


                    <v-card-text class="pl-12" v-for="(pM, index) in preguntasMaterias" :key="pM.id">
                        <v-card-title class="d-flex justify-left  text-body-1" :data-index="index">
                            {{ (pM.label != null ? pM.label + '.' : '') + pM.descripcion }}
                        </v-card-title>
                        <v-container fluid>
                            <v-textarea row-height="10" rows="2" v-if="pM.tipo_pregunta == 'text'"
                                v-model="pM.respuesta_value" :disabled="!llenar"></v-textarea>

                            <v-row v-for="respuesta in pM.respuestas" :key="respuesta.id"
                                v-else-if="pM.tipo_pregunta == 'option'">
                                <v-col cols="auto">
                                    <v-radio-group v-model="pM.respuesta_value" :disabled="!llenar">
                                        <v-radio :label="`${respuesta.descripcion}`" :value="respuesta.id"></v-radio>
                                    </v-radio-group>
                                </v-col>

                                <v-col v-if="respuesta.subpreguntas_datos && respuesta.subpreguntas_datos.length"
                                    cols="8">
                                    <v-row v-for="subpregunta in respuesta.subpreguntas_datos" :key="subpregunta.id">
                                        <v-col cols="6">

                                            <v-text-field v-if="subpregunta.tipo == 'text'" :disabled="!llenar"
                                                :label="subpregunta.label" v-model="subpregunta.respuesta_value" />
                                        </v-col>
                                        <v-col cols="12">
                                            <v-radio-group v-if="subpregunta.tipo == 'radio'" row
                                                v-model="subpregunta.respuesta_value" :disabled="!llenar">
                                                <v-radio v-for="(opc, inopc) in subpregunta.opciones" :key="inopc"
                                                    :label="`Tiene Previas: ${opc.label}`" :value="opc.id"></v-radio>
                                            </v-radio-group>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                            <v-checkbox-group v-model="pM.respuesta_value" v-else-if="pM.tipo_pregunta == 'multioption'"
                                :disabled="!llenar">
                                <v-checkbox v-for="respuesta in pM.respuestas" :key="respuesta.id"
                                    :label="respuesta.descripcion" :value="respuesta.id"></v-checkbox>
                            </v-checkbox-group>
                        </v-container>


                    </v-card-text>
                    <v-card-text class="pl-12">
                        <v-card-title class="d-flex justify-left  text-body-1">
                            4. Estado de situación de Materias al momento de ingresar (se recuerda que el plan de
                            estudios del secundario de adultos consta de 27 materias).
                            Marcar con X la materia que Usted tiene aprobada de su escuela anterior, la cual será una
                            equivalencia para el plan de CETAE.
                        </v-card-title>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12" sm="12" md="4" lg="4" v-for="(m, index) in materias" :key="index">
                                    <!-- <v-checkbox-group v-model="materiasSeleccionadas"> -->
                                    <v-checkbox :disabled="!llenar" v-model="materiasSeleccionadas"
                                        v-for="(mat, indexm) in m" :key="indexm" :label="mat.nombre"
                                        :value="mat.id"></v-checkbox>
                                    <!-- </v-checkbox-group> -->
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
                <v-card elevation="11" outlined shaped class="mt-5">
                    <v-card-title class="d-flex justify-left pl-16">DATOS SOBRE DOCUMENTACIÓN Y DISPOSITIVOS
                    </v-card-title>

                    <v-card-text class="pl-12" v-for="(pD, index) in preguntasDocumentos" :key="pD.id">
                        <v-card-title class="d-flex justify-left  text-body-1" :data-index="index">
                            {{ (pD.label != null ? pD.label + '.' : '') + pD.descripcion }}
                        </v-card-title>
                        <v-container fluid>
                            <v-textarea :disabled="!llenar" row-height="10" rows="2" v-if="pD.tipo_pregunta == 'text'"
                                v-model="pD.respuesta_value"></v-textarea>
                            <v-radio-group :disabled="!llenar" v-model="pD.respuesta_value"
                                v-else-if="pD.tipo_pregunta == 'option'">
                                <v-radio v-for="respuesta in pD.respuestas" :key="respuesta.id"
                                    :label="`${respuesta.descripcion}`" :value="respuesta.id"></v-radio>
                            </v-radio-group>
                            <!-- <v-checkbox-group v-model="selected" v-else-if="pD.tipo_pregunta == 'multioption'"> -->
                            <v-row v-for="respuesta in pD.respuestas" :key="respuesta.id"
                                v-else-if="pD.tipo_pregunta == 'multioption'">
                                <v-col cols="auto">
                                    <v-checkbox :disabled="!llenar" v-model="pD.respuesta_value"
                                        :label="respuesta.descripcion" :value="respuesta.id"></v-checkbox>
                                </v-col>

                                <v-col v-if="respuesta.subpreguntas_datos && respuesta.subpreguntas_datos.length"
                                    cols="8">
                                    <v-row v-for="subpregunta in respuesta.subpreguntas_datos" :key="subpregunta.id">
                                        <v-col>
                                            <v-text-field :disabled="!llenar" v-if="subpregunta.tipo == 'text'"
                                                :label="subpregunta.label" v-model="subpregunta.respuesta_value" />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>


                    </v-card-text>
                </v-card>
                <v-card elevation="11" outlined shaped class="mt-5">
                    <v-card-title class="d-flex justify-left pl-16">Horario de Contacto Deseado
                    </v-card-title>
                    <v-card-text>
                        <v-card-title class="d-flex justify-left  text-body-1">
                            1. Día:
                        </v-card-title>
                        <v-container fluid>
                            <v-menu v-model="menu" :disabled="!llenar" :close-on-content-click="false" :nudge-right="40"
                                transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field v-model="dia_preferencia" :disabled="!llenar"  label="Fecha" prepend-icon="mdi-calendar"
                                        readonly v-bind="attrs" v-on="on" clearable></v-text-field>
                                </template>
                                <v-date-picker v-model="dia_preferencia" :disabled="!llenar" @input="menu = false"></v-date-picker>
                            </v-menu>
                        </v-container>
                        <v-card-title class="d-flex justify-left  text-body-1">
                            2. Hora de Preferencia:
                            <v-container fluid>
                                <v-radio-group v-model="horario_preferencia" :disabled="!llenar">
                                    <v-radio v-for="ho in options_hora" :label="`${ho.text}`" :value="ho.value" :key="ho.value">

                                    </v-radio>
                                </v-radio-group>
                            </v-container>
                        </v-card-title>
                    </v-card-text>
                </v-card>
                <v-row align="center" class="mt-5">
                    <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6" v-if="llenar">
                        <v-btn color="success" elevation="7" large @click="guardarDatos()">
                            Guardar
                        </v-btn>
                    </v-col>
                </v-row>

                <v-row justify="center">
                    <v-dialog v-model="hayError" max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">Error</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-alert style="background-color: rgb(219, 29, 74);color: white;" icon="$success"
                                        title="Información"> {{ mensajeError }}</v-alert>

                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text @click="hayError = false">
                                    Close
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
                <v-row justify="center">
                    <v-dialog v-model="modalLleno" max-width="600px">
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">Ha completado el Formulario</span>
                            </v-card-title>
                            <v-card-text>
                                <v-container>
                                    <v-alert style="background-color: rgb(219, 29, 74);color: white;" icon="$success"
                                        title="Información">Este formulario solo puede ser llenado una vez. Ahora solo
                                        podrá
                                        visualizarlo en la sección "Documentos"</v-alert>

                                </v-container>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" text
                                    @click="modalLleno = false; $router.replace({ name: 'Home' })">
                                    Close
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-row>
                <br />
            </v-col>
        </CardIeaAppMain>
    </div>
</template>
<script>
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
    name: 'ContactoDatos',
    components: {
        CardIeaAppMain
    },
    data() {
        return {
            title: 'FICHA DE INSCRIPCIÓN PARA EL INICIO DE CURSADA NIVEL SECUNDARIO',
            subtitle: 'JURISDICCIÓN PROV. DE BS AS',
            preguntasMaterias: [],
            preguntasDocumentos: [],
            selected: null,
            materias: [],
            materiasSeleccionadas: [],
            respuestasAlumno: [],
            nombres: '',
            dni: '',
            edad: 0,
            formulario: null,
            llenar: true,
            mensajeError: '',
            hayError: false,
            modalLleno: false,
            dia_preferencia: '',
            menu: false,
            options_hora: [
                { text: '08:00 - 10:00', value: '08:00 - 10:00' },
                { text: '10:00 - 12:00', value: '10:00 - 12:00' },
                { text: '12:00 - 14:00', value: '12:00 - 14:00' },
                { text: '14:00 - 16:00', value: '14:00 - 16:00' },
                { text: '16:00 - 18:00', value: '16:00 - 18:00' },
                { text: '18:00 - 20:00', value: '18:00 - 20:00' },
                { text: '20:00 - 22:00', value: '20:00 - 22:00' },
            ],
            horario_preferencia:'',
            contacto:null
        }
    },
    computed: {
        user() {
            return this.$store.getters.user;
        },
    },
    methods: {
        async obtenerPreguntas() {

            let url = "contato-bce/obtener-preguntas/" + this.user.IDStB;
            await this.$API
                .get({
                    url: url
                }).then((res) => {
                    if (res.existe) {
                        this.preguntasMaterias = res.preguntasMateria
                        this.preguntasDocumentos = res.preguntasDocumentos
                        this.materias = res.materias
                        this.formulario = res.formulario
                        this.materiasSeleccionadas = res.materiasSeleccionadas
                        this.llenar = res.llenar
                        this.contacto=res.contactoBce

                        if(this.contacto){
                            this.horario_preferencia=this.contacto.horario_preferencia
                            this.dia_preferencia=this.contacto.dia_preferencia
                        }
                    } else {
                        alert("no se encontró un registro activo")
                    }

                });
        },
        async guardarDatos() {
            this.mensajeError = ''
            // if (this.materiasSeleccionadas.length == 0) {
            //     alert('No ha seleccionado materias');
            // }

            let errorPreguntasMaterias = false;
            let errorPreguntasDocumentos = false;
            this.preguntasMaterias.forEach(pM => {
                if (pM.tipo_pregunta == 'text') {
                    if (pM.respuesta_value == null || pM.respuesta_value == '') {
                        errorPreguntasMaterias = true;
                    }
                }
                if (pM.tipo_pregunta == 'option') {
                    if (pM.respuesta_value == null) {
                        errorPreguntasMaterias = true;
                    }
                }

                if (pM.tipo_pregunta == 'multioption') {
                    if (pM.respuesta_value.length == 0) {
                        errorPreguntasMaterias = true;
                    }
                }

                // let es_seleccionada=false;
                pM.respuestas.forEach(rM => {

                    if (pM.tipo_pregunta == 'option') {
                        if (rM.id != pM.respuesta_value) {
                            return;
                        }

                    }

                    if (pM.tipo_pregunta == 'multioption') {
                        if (!pM.respuesta_value.includes(rM.id)) {
                            return;
                        }
                    }
                    if (rM.tiene_subpreguntas) {
                        rM.subpreguntas_datos.forEach(sM => {
                            if (sM.tipo == 'text') {
                                if (sM.respuesta_value == null || sM.respuesta_value == "") {
                                    errorPreguntasMaterias = true;
                                }
                            }

                            if (sM.tipo == 'radio') {
                                if (sM.respuesta_value == null || sM.respuesta_value == "") {
                                    errorPreguntasMaterias = true;
                                }

                            }
                        })
                    }
                })
            });
            this.preguntasDocumentos.forEach(pD => {
                if (pD.tipo_pregunta == 'text') {
                    if (pD.respuesta_value == null || pD.respuesta_value == '') {
                        errorPreguntasDocumentos = true;
                    }
                }
                if (pD.tipo_pregunta == 'option') {
                    if (pD.respuesta_value == null) {
                        errorPreguntasDocumentos = true;
                    }
                }

                if (pD.tipo_pregunta == 'multioption') {
                    if (pD.respuesta_value.length == 0) {
                        errorPreguntasDocumentos = true;
                    }
                }

                pD.respuestas.forEach(rD => {

                    if (pD.tipo_pregunta == 'option') {
                        if (rD.id != pD.respuesta_value) {
                            return;
                        }

                    }

                    if (pD.tipo_pregunta == 'multioption') {
                        if (!pD.respuesta_value.includes(rD.id)) {
                            return;
                        }
                    }
                    if (rD.tiene_subpreguntas) {
                        rD.subpreguntas_datos.forEach(sD => {
                            if (sD.tipo == 'text') {
                                if (sD.respuesta_value == null || sD.respuesta_value == "") {
                                    errorPreguntasDocumentos = true;
                                }
                            }

                            if (sD.tipo == 'radio') {
                                if (sD.respuesta_value == null || sD.respuesta_value == "") {
                                    errorPreguntasDocumentos = true;
                                }

                            }
                        })
                    }
                })
            });

            if (errorPreguntasMaterias) {
                this.mensajeError += 'Falta llenar algunas preguntas en la sección: DATOS SOBRE MATERIAS Y AÑO DE MATRICULACIÓN.';
            }

            if (errorPreguntasDocumentos) {
                this.mensajeError += 'Falta llenar algunas preguntas en la sección: DATOS SOBRE DOCUMENTACIÓN Y DISPOSITIVOS';
            }

            if(this.dia_preferencia==''){
                this.mensajeError+=" Debe seleccionar el día de preferencia para su reunión"
            }

            if(this.horario_preferencia==''){
                this.mensajeError+=" Debe seleccionar el horario de preferencia"
            }

            if (this.mensajeError != '') {
                this.hayError = true;
                return false;
            }
            // console.log('llegamos aca')
            // return false;

            await this.$API
                .post({
                    url: "contacto-bce/guardar-formulario",
                    data: {
                        id_formulario: this.formulario.id,
                        formulario: this.formulario,
                        preguntasDocumentos: this.preguntasDocumentos,
                        preguntasMaterias: this.preguntasMaterias,
                        materias: this.materiasSeleccionadas,
                        dia_preferencia:this.dia_preferencia,
                        horario_preferencia:this.horario_preferencia
                    },
                })
                .then((res) => {
                    this.existeContactoBce = res.existe
                    this.contactoBce = res.contacto
                    this.modalLleno = true;
                    this.obtenerPreguntas();
                })

        }
    },
    mounted() {
        this.obtenerPreguntas();
    }
}
</script>
<style lang="">

</style>